module.exports = __webpack_public_path__ + "img/icons_increase.6070e066.svg";